// Lembrete diário de "projeto atual" (Etapa 14 — spec S03 §Notificação
// "projeto atual"): "lembrete diário discreto do projeto em andamento mais
// recente ... deep link direto para a Sessão. Horário configurável, off por
// padrão." Mesmo padrão de identificador persistido de
// src/features/session/pauseNotification.ts — cancelamento não pode
// depender de estado em memória (o app pode ser morto entre agendar e
// desligar a preferência).
//
// `content.data.kind` marca esta notificação para o listener de deep link
// em app/_layout.tsx distinguir de outras notificações locais do app (hoje,
// só o lembrete de pausa) sem abrir a Sessão por engano em resposta a ele.
import { Platform } from 'react-native';
import * as Notifications from 'expo-notifications';
import AsyncStorage from '@react-native-async-storage/async-storage';
import i18next from '../../i18n';

export const DAILY_REMINDER_KIND = 'daily-reminder';

const DAILY_REMINDER_ID_KEY = 'crochet:daily-reminder-notification-id';

/**
 * (Re)agenda o lembrete diário para `hour`:`minute` (hora local do
 * aparelho). Sempre cancela o agendamento anterior primeiro — reagendar com
 * um horário novo não deve deixar duas notificações diárias ativas. Mesmo
 * tratamento de permissão/erro de `schedulePauseReminder`: nunca deve
 * travar a tela de Preferências.
 */
export async function scheduleDailyReminder(hour: number, minute: number): Promise<void> {
  if (Platform.OS === 'web') return;
  try {
    await cancelDailyReminder();

    const current = await Notifications.getPermissionsAsync();
    const granted = current.granted || (await Notifications.requestPermissionsAsync()).granted;
    if (!granted) return;

    const id = await Notifications.scheduleNotificationAsync({
      content: {
        title: i18next.t('notifications.dailyReminder.title'),
        body: i18next.t('notifications.dailyReminder.body'),
        data: { kind: DAILY_REMINDER_KIND },
      },
      trigger: { hour, minute, repeats: true },
    });
    await AsyncStorage.setItem(DAILY_REMINDER_ID_KEY, id);
  } catch (error) {
    console.error('dailyReminder: falha ao agendar lembrete diário', error);
  }
}

/** Cancela só o lembrete diário (identificador próprio — não afeta o
 * lembrete de pausa). Sem-op silencioso se nada estava agendado. */
export async function cancelDailyReminder(): Promise<void> {
  if (Platform.OS === 'web') return;
  try {
    const id = await AsyncStorage.getItem(DAILY_REMINDER_ID_KEY);
    if (!id) return;
    await Notifications.cancelScheduledNotificationAsync(id);
    await AsyncStorage.removeItem(DAILY_REMINDER_ID_KEY);
  } catch (error) {
    console.error('dailyReminder: falha ao cancelar lembrete diário', error);
  }
}
